function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "icon_nosso_voo",
  "data-name": "icon nosso voo",
  transform: "translate(-7.5 675.164)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g4735",
  transform: "translate(10 -506.338)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4737",
  d: "M-473.768-37.837h-174.2a3.147,3.147,0,0,1-3.146-3.147v-7.87A3.147,3.147,0,0,1-647.965-52h174.2a3.147,3.147,0,0,1,3.147,3.147v7.87A3.147,3.147,0,0,1-473.768-37.837Z",
  transform: "translate(651.112 52)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4739",
  transform: "translate(130.327 -549.482)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4741",
  d: "M-72.123,0H-91.858a7.263,7.263,0,0,0-7.263,7.263",
  transform: "translate(99.121)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4743",
  transform: "translate(168.219 -549.482)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4745",
  d: "M-44.944-115.258v-35.881a7.263,7.263,0,0,0-7.263-7.263h-9.561",
  transform: "translate(61.768 158.402)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4747",
  transform: "translate(70.164 -609.403)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4749",
  d: "M-160.725-275.336v-95.8a7.263,7.263,0,0,0-7.263-7.263h-45.637a7.263,7.263,0,0,0-7.263,7.263v95.8",
  transform: "translate(220.889 378.402)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4751",
  transform: "translate(15.448 -565.824)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4753",
  d: "M0-129.811v-41.328A7.263,7.263,0,0,1,7.263-178.4h40.19a7.263,7.263,0,0,1,7.263,7.263",
  transform: "translate(0 178.402)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4755",
  transform: "translate(112.927 -666.687)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4757",
  d: "M-17.24,0H-3.694a2.258,2.258,0,0,1,2.03,3.254l-3.958,8.073A19.463,19.463,0,0,1-23.1,22.222h-.6",
  transform: "translate(23.693)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4759",
  transform: "translate(65.301 -666.687)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4761",
  d: "M-59.476-59.365h-.6A19.463,19.463,0,0,1-77.547-70.26l-3.958-8.073a2.258,2.258,0,0,1,2.03-3.254h13.546",
  transform: "translate(81.739 81.586)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4763",
  transform: "translate(93.917 -636.49)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4765",
  d: "M0-37.1V-50.993",
  transform: "translate(0 50.993)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4767",
  transform: "translate(106.574 -636.49)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4769",
  d: "M0,0V13.889",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4771",
  transform: "translate(84.003 -622.602)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4773",
  d: "M0-35.26v-8.98a4.219,4.219,0,0,1,4.219-4.218H28.266a4.219,4.219,0,0,1,4.219,4.218v8.98",
  transform: "translate(0 48.459)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4775",
  transform: "translate(81.104 -672.664)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4777",
  d: "M-68.042-96.638H-80.7A43.1,43.1,0,0,1-93.512-127.3v-4.1a1.406,1.406,0,0,1,1.406-1.406h35.471a1.406,1.406,0,0,1,1.407,1.406v4.1A43.1,43.1,0,0,1-68.042-96.638Z",
  transform: "translate(93.512 132.812)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4779",
  transform: "translate(97.773 -569.436)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4781",
  d: "M0,0H4.944V23.131",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4783",
  transform: "translate(36.452 -547.873)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4785",
  d: "M-33.946-62.861S-45.2-62.72-45.734-62.9s.855-1.116,8.233-11.659a14.884,14.884,0,0,0,2.459-5.021l.114-.895a5.919,5.919,0,0,0-5.919-5.919,5.92,5.92,0,0,0-5.808,4.772",
  transform: "translate(46.653 86.392)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4787",
  transform: "translate(151.877 -539.747)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4789",
  d: "M0-12.747a5.921,5.921,0,0,1,5.808-4.772A5.919,5.919,0,0,1,11.727-11.6,5.919,5.919,0,0,1,5.808-5.681",
  transform: "translate(0 17.519)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "g4791",
  transform: "translate(151.766 -527.91)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4793",
  d: "M-15.812,0A5.919,5.919,0,0,1-9.893,5.919a5.919,5.919,0,0,1-5.919,5.919,5.92,5.92,0,0,1-5.862-5.093,5.953,5.953,0,0,1-.057-.825",
  transform: "translate(21.731)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})));

const SvgIconNossoVoo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 185.49,
  height: 185.49,
  viewBox: "0 0 185.49 185.49",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNossoVoo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-nosso-voo.0b2b6775.svg";
export { ForwardRef as ReactComponent };